var strapCheckedAmount = 0;
$(".secondStrap").on("click", function () {
  var t = $(".secondStrap").length / 3,
    a = $(".addSecondStrapContainerTitle"),
    e = $(".secondStrapAddedProductTitle"),
    i = $(this).data("index"),
    s = $(this).find(".stf"),
    o = $(this).find(".secondStrapPrice span.money"),
    r = $(this).find(".strapCheckboxWrapper .strapCheckbox  span.added"),
    c = $(".regular-price_val .money").text().split(" ")[0],
    l = $(this).find(".tpProductSelect"),
    n = $(".regular-price_val .money")
      .text()
      .replace(/[^\d\.]/g, ""),
    d = $(".regular-price_val .money").text(),
    p = $(this).find("span.money").attr("doubly-currency-aed"),
    p = $(this).find(".secondStrapPrice").find("span.money").text(),
    u = parseFloat(0),
    h = parseFloat(0),
    v = d.charAt(0),
    m = parseFloat(d.replace(/[^\d\.]/g, "")),
    f = parseFloat(p.replace(/[^\d\.]/g, ""));
  p = void 0 == p ? 0 : p;
  var g = parseFloat(f),
    y = parseFloat(n.toString().replace(",", ""));
  h += y;
  var k = parseFloat(f),
    b = parseFloat(n);
  if (((u += b), $(this).hasClass("strapActive"))) {
    strapCheckedAmount--, $(this).removeClass("strapActive");
    var C = $(this).find(".tpProductSelect").val();
    $(this).parents("li.item").attr("data_variant_id", "");
    for (
      var w = $('[data-block-type = "buy-buttons"] .shopify-product-form').find(
          ".product_id input"
        ),
        x = 0;
      x < w.length;
      x++
    )
      console.log(w[x]), w[x].value == C && w[x].remove();
    o.show(),
      r.text(""),
      e.find("span[data-index=" + i + "]").remove(),
      l.prop("checked", !1),
      (u -= k);
    var A = parseFloat(m) - parseFloat(f);
    let S = "";
    (S = v.replace(/[^0-9]/g, "") ? A.toFixed(2) + " د.إ" : v + A.toFixed(2)),
      $(".price-list").find(".regular-price_val .money").empty().text(S),
      (h -= g),
      u.toFixed(2),
      $(".fixedBarprice").html(S);
  } else {
    strapCheckedAmount++, $(this).addClass("strapActive");
    var C = $(this).find(".tpProductSelect").val();
    $(this).parents("li.item").attr("data_variant_id", C);
    var _ =
      '<input type="hidden" name="id" value="' +
      $(this).find(".tpProductSelect").val() +
      '">';
    $('[data-block-type = "buy-buttons"] .shopify-product-form')
      .find(".product_id")
      .append(_),
      r.text("Added"),
      e.append('<span data-index="' + i + '">' + s.text() + "</span>"),
      l.prop("checked", !0),
      (u += k);
    var A = parseFloat(m) + parseFloat(f);
    let I = "";
    v.replace(/[^0-9]/g, "")
      ? (I = A.toFixed(2) + " د.إ")
      : ((I = v + " " + A.toFixed(2)), console.log("after", c)),
      $(".price-list").find(".regular-price_val .money").empty().text(I),
      (h += g),
      u.toFixed(2),
      $(".fixedBarprice").html(I);
  }
  0 == strapCheckedAmount
    ? a.show().find("span").text("A Second")
    : t == strapCheckedAmount
    ? a.show().find("span").text("A Third")
    : 1 == strapCheckedAmount
    ? a.show().find("span").text("A Third")
    : 2 == strapCheckedAmount
    ? a.show().find("span").text("A Fourth")
    : 3 == strapCheckedAmount
    ? a.show().find("span").text("A Fifth")
    : 4 == strapCheckedAmount
    ? a.hide()
    : 5 == strapCheckedAmount
    ? a.hide()
    : a.show().find("span").text("Another");
});
$(".variant-picker__option .sr-only").on("change", function () {
    $(this);
    // var t, a = $(this).attr("data_va_id").trim().replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, ""),
    var t, a = $(this).attr("data_va_id"),
      e = $(this).parents(".custom_product_page").find(".product-gallery_new product-gallery-navigation button"),
      i = $(this).parents(".custom_product_page").find(".product-gallery__image-list_data scroll-carousel .product-gallery__media");
    for (
      $(e).each(function () {
        ($(this).hasClass("active_img") || $(this).hasClass("dactive_img")) &&
          ($(this).removeClass("dactive_img"),
          $(this).removeClass("active_img"));
      }),
        $(i).each(function () {
          ($(this).hasClass("active_img") || $(this).hasClass("dactive_img")) &&
            ($(this).removeClass("dactive_img"),
            $(this).removeClass("active_img"));
        }),
        t = 0;
      t < e.length;
      t++
    ) {
      var s = e[t].attributes.data_var_id.value.replace(
        /[&\/\\#, +()$~%.'":*?<>{}_-]/g,
        ""
      );
      a === s
        ? e[t].classList.add("active_img")
        : e[t].classList.add("dactive_img");
    }
    for (t = 0; t < i.length; t++) {
      var s = i[t].attributes.data_var_id1.value.replace(
        /[&\/\\#, +()$~%.'":*?<>{}_-]/g,
        ""
      );
      a === s
        ? i[t].classList.add("active_img")
        : i[t].classList.add("dactive_img");
    }
    $(".custom-overlay").css("display", "none"),
      $(".custom-popup").removeClass("right0");
      // $("html").css("overflow-y", "scroll");
  });
var val_ch_data = $(".custom_product_page").find(
  ".product-gallery_new product-gallery-navigation button"
);
$(val_ch_data).on("click", function () {
  var t = $(
    ".custom_product_page .product-gallery__image-list_data scroll-carousel .product-gallery__media"
  );
  $(t).each(function () {
    $(this).hasClass("dactive_img") &&
      ($(this).removeClass("dactive_img"), $(this).removeClass("active_img"));
  });
}),
  $("safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button").on("click", function () {
    // debugger;
    var t = $(this).attr("data-media-id");
    $(".product-gallery__image-list_data scroll-carousel .product-gallery__media").removeClass("image_display_none  , image_display"),
    $(".product-gallery__image-list_data scroll-carousel figure.prod_img").removeClass("img_show"),
      $(".product-gallery__image-list_data scroll-carousel .product-gallery__media").each(function () {
        var a = $(this);
        $(this).attr("data-media-id") == t ? a.addClass("image_display") : a.addClass("image_display_none");
         $(this).attr("data-media-id") == t ? $(this).parents('figure.prod_img').addClass("img_show") : $(this).parents('figure.prod_img').removeClass("img_show");
      });
  }),
  $(document).on("click", ".cart-drawer__items .close-cart", function () {
    $(this)
      .parents(".Cart__ItemList ")
      .find("#cart_popup_val")
      .css("display", "block");
  }),
  $(document).on("click", ".cancel_cart  #new_ps_close", function () {
    $(this)
      .parents(".Cart__ItemList ")
      .find("#cart_popup_val")
      .css("display", "none");
  }),
  $(".search_header_val .modal-header svg").on("click", function () {
    $("header-search.header-search").css("display", "none"),
      $("header-search.header-search").removeAttr("open"),
      $("html").removeClass("lock"),
      $(".search_click").attr("aria-expanded", "false");
  }),
  $(document).ready(function () {
    $('.shopify-section--shop-the-look button[type="button"]').on(
      "click",
      function () {
        $(
          "shop-the-look-desktop-carousel.shop-the-look__carousel .shop-the-look__item"
        ).each(function () {
          // console.log($(this).addClass("is-selected"));
        });
      }
    ),
      $(".icofont-close-line").on("click", function () {
        $(".login_popup_model.modal").css("display", "none"),
          $("body").removeClass("login_popup_overlay");
      });
    var t = document.getElementById("myModal");
    (window.onclick = function (a) {
      a.target == t && (t.style.display = "none");
    }),
      $(".custom-flex").click(function () {
        $(this).find(".custom-overlay").css("display", "block"),
          $(this).find(".custom-popup").addClass("right0"),
          $("body").css("overflow-y", "hidden");
      }),
      $(document).on("click", ".custom-close", function () {
        $(".custom-overlay").css("display", "none"),
          $(this).parents(".custom-popup").removeClass("right0"),
          $("body").css("overflow-y", "scroll");
      }),
      $(document).on("click", ".custom-overlay", function () {
        $(this).css("display", "none"),
          $(this).next(".custom-popup").removeClass("right0"),
          $("body").css("overflow-y", "scroll");
      }),
    $(".sizeguard , .see-the-fit-btn").on("click", function () {
        $(".bs-example-modal-lg2").fadeIn();
        // $(".bs-example-modal-lg2").css("display", "block");
        $(".bs-example-modal-lg2").addClass("in");
      }),
      $(".care-main-btn").on("click", function () {
        $(".bs-example-modal-care").fadeIn();
        // $(".bs-example-modal-care").css("display", "block");
      }),
      $(".modal .close-btn").on("click", function () {
        $(".bs-example-modal-lg2").fadeOut();
        // $(".bs-example-modal-lg2").css("display", "none");
        // $(".bs-example-modal-lg2").css("top","-150%");
        $(".bs-example-modal-care").fadeOut();
        // $(".bs-example-modal-care").css("display", "none");
        $(".bs-example-modal-lg2").removeClass("in");
      }),
      $("html[lang='en'] .custom-shipping-mobile-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: !0,
        autoplay: !0,
        autoplaySpeed: 0,
        speed: 6e3,
        pauseOnHover: !1,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 768,
            settings: { slidesToShow: 1.5, slidesToScroll: 1 },
          },
        ],
      }),
      $(".explr-serie-carousel").slick({
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: !0,
        dots: !1,
      }),
      $("ul.tabs li").click(function () {
        $(this).addClass("active"),
          $(this).siblings("ul.tabs li").removeClass("active");
        var t = $(this).attr("rel");
        $("." + t).addClass("active_content"),
          $("." + t)
            .siblings(".tab_content")
            .removeClass("active_content"),
          $(".tab_drawer_heading[rel^='" + t + "']").addClass("d_active"),
          $(".tab_drawer_heading[rel^='" + t + "']")
            .siblings(".tab_drawer_heading")
            .removeClass("d_active");
      }),
    $(".tab_drawer_heading").on("click", function () {
    $(this).css('pointer-events', 'none');
    if ($(this).hasClass("d_active")) {
      $(this).next().slideUp();
        $(this).removeClass("d_active");
        $(this).next().removeClass("active_content");        
    } else {
       $(this).next().slideDown();
        $(this).addClass("d_active");
        $(this).next().addClass("active_content");
    }
      setTimeout(function(){ $('.tab_drawer_heading').css('pointer-events', 'auto');},400);
}),
      $(".galary-slides .li_st").click(function () {
        // debugger;
        var t = $(this).find("img").attr("src");
        $("#small-slider-zoom").html(" "),
          $("#small-slider-zoom").prepend(
            '<img id="mobile_zoom_effect" src="' + t + '" />'
          ),
          // $("#mobile_zoom_effect")
          //   .wrap('<span class="zoom" style="display:inline-block;"></span>')
          //   .css("display", "block")
          //   .parent(),
          $('#mobile_zoom_effect')
    .wrap('<span class="zoom" style="display:inline-block;"></span>')
    .css('display', 'block')
    .parent()
    .zoom({ on:'click',touch:'true', zoomWindowWidth:1200, zoomWindowHeight:1200});
          $(".model_img").css("display", "block");
      }),
      $(".close_popup").click(function () {
        $(".model_img").css("display", "none"),
          $("#small-slider-zoom").prepend(""),
          $("#small-slider-zoom").find("span").remove();
      }),
      $(".variant-picker__option-info").on("click", function () {
        var t = $(this)
            .next(".variant-picker__option-values")
            .attr("data_option_val"),
          a = $(this).attr("data_option_name");
        $("variant-option-value").text(),
          t === a
            ? ($(this)
                .next()
                .find(".custom-popup")
                .addClass("custom_popup_drop"),
              $(this).next().find(".custom-overlay").css("display", "block"))
            : $(this)
                .next()
                .find(".custom-popup")
                .removeClass("custom_popup_drop");
      }),
      $(".custom-close").on("click", function () {
        $(this)
          .parents(".variant-picker__option-values .custom-popup")
          .removeClass("custom_popup_drop");
      }),
      $(".custom-popup .swatch-products a.custom-popup-product label").on("click",function () {
          $(".custom-popup").removeClass("custom_popup_drop");
        }),
      $(".variant-picker__option-values .custom-overlay").on(
        "click",
        function () {
          $(this).css("display", "none"),
            $(".custom-popup").removeClass("custom_popup_drop");
        }
      ),
      $(
        ".variant-picker__option-values .custom-popup .custom-popup-product label"
      ).on("click", function () {
        var t = "",
          a = $(this).parents(".custom-popup").attr("name_of_var");
        $(
          ".product-gallery__image-list_data scroll-carousel .product-gallery__media"
        ).removeClass("image_display_none  , image_display");
        var e = $(this).prev().val();
        if (
          ($("variant-option-value").each(function () {
            var t = $(this).attr("class");
            a == t &&
              $("variant-option-value." + t)
                .empty()
                .append(e);
          }),
          $(this).hasClass("media-swatch"))
        ) {
          var i = $(this)
            .prev("input")
            .attr("value")
            .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, "");
          $(this)
            .parents(".swatch-products")
            .find(".custom-popup-product input")
            .removeAttr("checked"),
            $(this).prev("input").attr("checked", "checked");
          var s = $(this)
            .parents("variant-picker")
            .find(".swatch-products .custom-popup-product label.block-swatch")
            .prev("input:checked")
            .val();
          t += i + s;
        } else if ($(this).hasClass("block-swatch")) {
          var i = $(this)
            .prev("input")
            .attr("value")
            .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, "");
          $(this)
            .parents(".swatch-products")
            .find(".custom-popup-product input")
            .removeAttr("checked"),
            $(this).prev("input").attr("checked", "checked");
          var s = $(this)
            .parents("variant-picker")
            .find(".swatch-products .custom-popup-product label.media-swatch")
            .prev("input:checked")
            .val();
          t += s + i;
        }
        var o = t.replace(" ", "");
        $(
          "safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button"
        ),
          $("scroll-carousel .product-gallery__media"),
          $(
            "safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button"
          ).removeClass("active_img reactive_img"),
          $("scroll-carousel .product-gallery__media").removeClass(
            "active_img_bar reactive_img_bar"
          ),
          $("carousel-navigation button.tap-area").removeClass(
            "active_img_dots reactive_img_dots"
          ),
          $(
            "safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button"
          ).each(function () {
            var t = $(this);
            $(this).attr("data_var_id") == o
              ? t.addClass("active_img")
              : t.addClass("reactive_img");
          }),
          $(
            ".product-gallery__image-list_data scroll-carousel .product-gallery__media"
          ).each(function () {
            var t = $(this);
            $(this).attr("daat_var_val_di") == o
              ? t.addClass("active_img_bar")
              : t.addClass("reactive_img_bar");
          }),
          $("carousel-navigation button.tap-area").each(function () {            
            var t = $(this);
            $(this).attr("var_data_meid") == o
              ? t.addClass("active_img_dots")
              : t.addClass("reactive_img_dots");
          }),
          $(".product_var_id input").each(function () {
            if ($(this).val().includes(o)) {
              let t = $(this).attr("data-id");
              $(".product .var_id_val1").empty().append(t);
            } else $(this);
          });
        var r = $(".product .var_id_val1").text();
        $(".product_custom .variant_id").removeClass(
          "active_details deactive_details"
        ),
          $(".product_custom .variant_id").each(function () {
            $(this).attr("var_id").includes(r)
              ? $(this).addClass("active_details")
              : $(this).addClass("deactive_details");
          });
        var c = "";
        $(".product_var_id").each(function () {
          $(this).find("input").attr("value") == o &&
            (c += $(this).find("input").attr("data-id"));
        }),
          $(".upsell_variant").removeClass("active_upsell deactive_upsell"),
          $(".upsell_variant").each(function () {
            $(this).attr("variant_upsell") == c
              ? $(this).addClass("active_upsell")
              : $(this).addClass("deactive_upsell");
          });
        var l = $(this)
          .attr("data_sel_val")
          .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, "");
        $(".product_var_id input").each(function () {
          if (
            $(this)
              .attr("var_name")
              .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, "") == l
          ) {
            var t = $(this).attr("data-id");
            $(
              '.product .product-info__block-item .shopify-product-form input[name="id"]'
            ).attr("value", t);
            var a = $(this).attr("var_avilabel");
            "false" == a
              ? $(
                  ".product .product-info__block-item .shopify-product-form buy-buttons button"
                )
                  .empty()
                  .text("Sold out")
              : "true" == a &&
                $(
                  ".product .product-info__block-item .shopify-product-form buy-buttons button"
                )
                  .empty()
                  .text("ADD TO Cart");
          } else $(this);
        }),
          $(".custom-overlay").css("display", "none");
      }),
      $(window).on("load", function () {
        let t = "";
        $(".variant-picker__option").each(function () {
          t += $(this)
            .find(
              ".variant-picker__option-values .custom-popup-product input:checked"
            )
            .val();
        });
        let a = t.replace(" ", "");
        var e = $(
          ".variant-picker__option-values .custom-popup-product label.media-swatch"
        )
          .prev("input:checked")
          .val();
        $(
          ".variant-picker__option-values .custom-popup label.block-swatch "
        ).removeClass("var_sel_stone var_desel_stone"),
          $(
            ".variant-picker__option-values .custom-popup label.block-swatch"
          ).each(function () {
            $(this).attr("default_active_sto") == e
              ? $(this).addClass("var_sel_stone")
              : $(this).addClass("var_desel_stone");
          }),
          $(
            ".product-gallery__image-list_data scroll-carousel .product-gallery__media"
          ).each(function () {
            var t = $(this);
            $(this).attr("daat_var_val_di") == a
              ? t.addClass("active_img_bar")
              : t.addClass("reactive_img_bar");
          }),
          $(
            "safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button"
          ).each(function () {
            var t = $(this);
            $(this).attr("data_var_id") == a
              ? t.addClass("active_img")
              : t.addClass("reactive_img");
          }),
          $("carousel-navigation button.tap-area").each(function () {
            var t = $(this);
            $(this).attr("var_data_meid") == a
              ? t.addClass("active_img_dots")
              : t.addClass("reactive_img_dots");
          });
        var i = $(".product .var_id_val1").text();
        $(".product_custom .variant_id").removeClass(
          "active_details deactive_details"
        ),
          $(".product_custom .variant_id").each(function () {
            $(this).attr("var_id").includes(i)
              ? $(this).addClass("active_details")
              : $(this).addClass("deactive_details");
          }),
          $(".upsell_variant").removeClass("active_upsell deactive_upsell"),
          $(".upsell_variant").each(function () {
            $(this).attr("variant_upsell").includes(i)
              ? $(this).addClass("active_upsell")
              : $(this).addClass("deactive_upsell");
          });
      }),
      $(
        ".variant-picker__option-values .custom-popup .custom-popup-product label.media-swatch"
      ).on("click", function () {
        var t = $(this)
            .prev("input")
            .val()
            .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, ""),
          a = $(".product").find('.product_var_id input[type="hidden"]'),
          e = [],
          i = 0;
        $(a).each(function () {
          $(this).attr("vari_first") === t
            ? ($(this).attr("vari_secon"), (e[i++] = $(this).attr("var_name")))
            : $(this);
        }),
          $(
            ".variant-picker__option-values .custom-popup label.block-swatch "
          ).removeClass("var_sel_stone var_desel_stone");
        for (
          var s = $(
              ".variant-picker__option-values .custom-popup label.block-swatch"
            ),
            o = 0;
          o < s.length;
          o++
        )
          for (
            var r = s[o].attributes.data_sel_val.value, c = 0;
            c < e.length;
            c++
          )
            e[c] == r
              ? (s[o].className += "  var_sel_stone  ")
              : (s[o].className += "  var_desel_stone  ");
      }),
      $(".toggle-view li").click(function () {
        var t = $(this).children("div.panel");
        t.is(":hidden")
          ? (t.slideDown("200"),
            $(this).children("span").html('<i class="icofont-thin-up"></i>'))
          : (t.slideUp("200"),
            $(this).children("span").html('<i class="icofont-thin-down"></i>'));
      });
    var a = $(".NS_wrapper.rev_iew_cl")
      .find("#judgeme_product_reviews")
      .attr("style");
    void 0 !== a &&
      a.includes("none") &&
      $(".NS_wrapper.rev_iew_cl").css("min-height", "30px"),
      $("#custom-numbers li.clickable").click(function () {
        $("#custom-numbers li").removeClass("active"),
          $(this).addClass("active");
        var t = $(this).find("input").val();
        console.log(t),
          $(this)
            .parents(".main_product_fu")
            .find(".product-single__variants")
            .val(t)
            .trigger("change");
      }),
      "Womens Gift Box" == $(".custom-swatch-selection .swatch_inner").attr("data-vendor") && $(this).parent(".custom-swatch-selection").css("display", "none");
  });

// 13-06-2025
  function showTextareaSmooth(ele) {
  $(ele).css({
    display: 'block',
    height: 'auto',
    opacity: 0
  });
  let height = $(ele).prop('scrollHeight') + 'px';
  $(ele).css({ height: '0px' });
  void ele.offsetWidth;
  $(ele).css({
    height: height,
    opacity: 1,
    transition: 'height 0.3s ease, opacity 0.3s ease'
  });
}
function hideTextareaSmooth(ele) {
  let height = $(ele).prop('scrollHeight') + 'px';
  $(ele).css({
    height: height,
    opacity: 1
  });
  void ele.offsetWidth;
  $(ele).css({
    height: '0px',
    opacity: 0,
    transition: 'height 0.3s ease, opacity 0.3s ease'
  });
}
$(".gift_note_pro").val("");
$(".comp_checkbox .comp_label").click(function(){ 
$('.comp_checkbox.gift_che').find('#gift_box').attr('value' , '' );
  $('.comp_checkbox').addClass("gift_che");
    $(".comp_checkbox .box_gift").removeClass("gift_check");
    $(".comp_checkbox input[type='checkbox']").not($(this).find("input[type='checkbox']")).prop("checked",false);
   $(".comp_checkbox input[type='checkbox']").not($(this).find("input[type='checkbox']")).removeClass("gift_che");
   // $(".comp_checkbox input[type='checkbox']").not($(this).find("input[type='checkbox']")).(".box_gift").removeClass("gift_check");;
       var note_gift = $(this).parents('.comp_checkbox_wrap').find('.gift_note_pro');
  if($(this).find("input[type='checkbox']").prop("checked") == false){
        $(this).find("input[type='checkbox']").prop("checked",true);
     $(this).find(".checkmark").removeClass("remove_check");
     // $(".gift_note_pro").stop().slideDown();
    showTextareaSmooth(note_gift[0]);
      $('.comp_checkbox').addClass("gift_che");
    $(this).parents(".box_gift").addClass("gift_check");
    var gift_box = $(this).find('.limited_edition').text();
    $('.comp_checkbox.gift_che').find('#gift_box').attr('name' , 'properties[Gift Wrapping Type]' );
    $('.comp_checkbox.gift_che').find('#gift_box').attr('value' , gift_box );
    $('.comp_checkbox_wrap').addClass("gift_che_add");
  }
    else{
        $(this).find("input[type='checkbox']").prop("checked",false);
       $(this).find(".checkmark").addClass("remove_check");
      // $(".gift_note_pro").stop().slideUp();
       hideTextareaSmooth(note_gift[0]);
      	$(".gift_note_pro").val("");
        $('.comp_checkbox').removeClass("gift_che");
        $(this).parents(".box_gift").removeClass("gift_check");
       $(".gift_note_pro").removeAttr("name","properties[Cart Note]");
       $('.comp_checkbox_wrap').removeClass("gift_che_add");
    }

  if( $(".gift_note_pro").val().length == 0){ $(".gift_note_pro").removeAttr("name","properties[Cart Note]"); }

});
$('.gift_note_pro').keyup(function() { 
  var characterCount = $(this).val().length;
  if(characterCount == 0){
     // $('.comp_checkbox_wrap').removeClass("gift_che_add");
    $(this).removeAttr("name","properties[Card Note]");    
  }else
  {
     // $('.comp_checkbox_wrap').addClass("gift_che_add");
    $(this).attr("name","properties[Card Note]");
  }

});

// 13-06-2025


$(document).ready(function(){
function calculateAndUpdateHeight() {
  if($(window).width() <= 767){
      var height; 
      $('.secondStrap .secondStrapImg').each(function() {
          height = $(this).height();
          return false; 
      });
      var secondStrapMarginTop = parseInt($('.secondStrap').css('margin-top'));
      var totalHeight = height / 2;
      var topArraow = (totalHeight + secondStrapMarginTop) - 20;
     $('.secondStrapSlider .owl-next,.secondStrapSlider .owl-prev').css('top', topArraow + 'px');
  }
}
$(window).on('load', calculateAndUpdateHeight);
var resizeTimer;
$(window).on('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
      calculateAndUpdateHeight();
  }, 200);
});
});


$(document).ready(function(){
  $(document).on('click' , '.custom-swatch',function(){
    // debugger;
    // alert();
    var hiddenImg = $(this).find('input').val();
    var hiddenUrl = $(this).find('input').attr('data-url');
    var soldout = $(this).find('input').attr('data-soldout').trim();
    var newTag = $(this).find('input').attr('data-newtag').trim();
    var proLab = $(this).find('input').attr('data-proLab').trim();

    var women_attr = $(this).find('input').attr('data-womentag');
    if (typeof women_attr !== 'undefined' && women_attr !== false) {
   var womentag =   $(this).find('input').attr('data-womentag').trim();
}

    // 22-12-2024
   $(this).parents('.customcoll').find('.product-card__figure a').attr('href' , hiddenUrl);
    // 22-12-2024
  
    var hiddenTitle = $(this).find('input').attr('data-title');
     var contant = $(this).find('input').attr('data-price');
    var compare_price = $(this).find('input').attr('data-compare-price');
      var part = contant.split('>')[1];
    var currency_val = part.split('<')[0];

    $(this).parents('.customcoll').find('.ProductItem__Info .custom_blank_wrapper').addClass('custom_color_selct');
    
    // var currency_val = $(this).parents('.customcoll').find('.ProductItem__Info .price_flex .money').text();
    $(this).parents('.customcoll').find('.custom-swatch').removeClass('is-active');
    $(this).parents('.customcoll').find('.ProductItem__Image').attr('src',hiddenImg);
$(this).parents(".ProductItem").find(".ProductItem__Image").attr("srcset",hiddenImg);
   if ($('.custom_newtag').is(':empty')){             $(this).parents('.customcoll').find('span.custom_newtag').remove();}
    if(soldout === ''){
      
      $(this).parents('.customcoll').find('span.custom_blank span.custom_newred').remove();
      if(newTag === ''){
      // $(this).parents('.customcoll').find('span.custom_blank .custom_newred').remove();
        $(this).parents('.customcoll').find('span.custom_blank span.custom_newtag').remove();
      }
      else{
        $(this).parents('.customcoll').find('.ProductItem__Info .custom_blank_wrapper span.custom_blank').empty().append('<span class="custom_newtag" style="">'+ newTag +'</span>');
      }
      if(proLab === ''){
        $(this).parents('.customcoll').find('span.custom_blank .pro_label').remove();
      }else{
        var arr = proLab.split(',');
        var newarr = Object.keys(arr).map(key => arr[key])
       console.log('arr'+typeof(newarr));
        var avoid =", ";
        proLab = proLab.replace(avoid,'');
        
$(this).parents('.customcoll').find('.ProductItem__Info .custom_blank_wrapper span.custom_blank .pro_label').remove();
        
for(var i=0; i< arr.length; i++){

// console.log('proLab'+proLab);
if(arr[i] != ''){
        $(this).parents('.customcoll').find('.ProductItem__Info .custom_blank_wrapper span.custom_blank').append('<span class="pro_label" style="">'+ arr[i] +'</span>');
}
}
      }


 if(womentag === '' || typeof womentag === 'undefined'){
      $(this).parents('.customcoll').find('span.custom_blank .custom_newtag.womendays').remove();
      }
      else{
        $(this).parents('.customcoll').find('span.custom_blank').append('<span class="custom_newtag womendays">'+ womentag +'</span>');
      }
      
    }
    else{
       if(newTag === ''){
      $(this).parents('.customcoll').find('span.custom_blank .custom_newtag').remove();
      }
      else{
        $(this).parents('.customcoll').find('.ProductItem__Info .custom_blank_wrapper span.custom_blank .custom_newtag').empty().append(newTag);
      }

      if(womentag === ''){
      $(this).parents('.customcoll').find('span.custom_blank .custom_newtag.womendays').remove();
      }
      else{
        $(this).parents('.customcoll').find('span.custom_blank').empty().append('<span class="custom_newtag womendays">'+ womentag +'</span>');
      }
      
    $(this).parents('.customcoll').find('.ProductItem__Info .custom_blank_wrapper span.custom_blank').empty().append('<span class="custom_newred"><ly-as-250000>'+ soldout +'</ly-as-250000></span>');
    }
    $(this).addClass('is-active');
     $(this).parents('.customcoll').find('.ProductItem__ImageWrapper').attr('href', hiddenUrl);
     $(this).parents('.customcoll').find('.ProductItem__ImageWrapper a').eq(0).attr('href', hiddenUrl);
    $(this).parents('.customcoll').find('.pro_vendor_title a').attr('href', hiddenUrl);
    $(this).parents('.customcoll').find('.pro_vendor_title .productTitle').text(hiddenTitle);
 
    // debugger;

// var current_currency = DoublyGlobalCurrency.currentCurrency;
// var Currency = {   rates: DoublyGlobalCurrency.rates,
//     convert: function (amount_value, from, to) { return amount_value * this.rates[from] / this.rates[to]; }
// };
//     var amount_value = currency_val.split(' ')[0];
//  // 25-11-2024 start
//     if(amount_value.includes(',')){    amount_value = amount_value.replace(',' , ''); }
// // 25-11-2024 end
//     var fromCurrency = 'AED';
//     var toCurrency = current_currency;
//     if (Currency.rates[fromCurrency] && Currency.rates[toCurrency]) {
//       var convertedAmount = parseInt(Currency.convert(amount_value, fromCurrency, toCurrency));
//        var format = DoublyGlobalCurrency.moneyFormats[toCurrency].money_format;
//        if( toCurrency.toUpperCase() == 'AED'){ var final_product = convertedAmount.toLocaleString()+'.00'; }else{ 
//            if(format.includes("amount_with_comma_separator")){ var final_product = convertedAmount.toLocaleString()+',99'; }else{ var final_product = convertedAmount.toLocaleString()+'.99'; } }
      
//         // var displayedAmount = format.replace( '{{amount}}' , final_product);

//         if(format.includes("amount_with_comma_separator")){   var displayedAmount = format.replace( '{{amount_with_comma_separator}}' , final_product);
//       }else{     var displayedAmount = format.replace( '{{amount}}' , final_product);     }
      
//        $(this).parents('.customcoll').find('.ProductItem__Info .price_flex .money').empty().append(displayedAmount);
//     } else {
//         console.log('Invalid currency code');
//         console.log('');
//     }

          $(this).parents('.customcoll').find('.ProductItem__Info .price_flex .ProductItem__Price').empty().append(contant);
      if(compare_price){
          $(this).parents('.customcoll').find('.ProductItem__Info .price_flex .product_compare_price_value  .ProductItem__Price').empty().append(compare_price);
      }
    
    
  });
});

// modal close outside click PDP page
$('.bs-example-modal-lg2').on('click', function(event) { if (event.target === this) { $("body").find(".bs-example-modal-lg2").hide(); } });
$(document).ready(function() {
  if($('.shopify-section--main-collection').length > 0){
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        var sectionOffset = $('.shopify-section--main-collection').offset().top;

        if (scroll >= sectionOffset) {
            $('.shopify-section--main-collection').addClass('filter_section_call');
        } else {
            $('.shopify-section--main-collection').removeClass('filter_section_call');
        }
    });
  }
});



// optimization code
let isUpdatingCartSavings = false;
function updateCartSavingsdisc() {
  // debugger;
 if (isUpdatingCartSavings) return Promise.resolve(); 
  isUpdatingCartSavings = true;
  return new Promise((resolve, reject) => {
let totalPriceSub = 0;
    let compare_price_main = 0
   $.getJSON('/cart.js', function (fetchCart) {
        let productPromises = fetchCart.items.map(item => {
            return $.getJSON(`/products/${item.handle}.js`).then(product => {
                return { item: { ...item, key: item.key }, product };
            });
        });
      Promise.all(productPromises).then(results => {
            let allCompareAtPriceZero = true;
              let item_drawer_keyval = document.querySelectorAll('.cart-drawer__items .Cart__ItemList');
            results.forEach(({ item, product }) => {
                let selectedVariant = product.variants.find(v => v.id === item.variant_id) || product.variants[0];

                if (!selectedVariant) return;

                   let mainPriceQuantity = selectedVariant.compare_at_price * item.quantity;       
                let mainSavingPrice = mainPriceQuantity - item.line_price;
                let priceListHTML = "";

                // Only show savings if there's a valid compare_at_price greater than price
              if (fetchCart.total_discount > 0) {
                 let mainPriceQuantityDiscount;
if (selectedVariant.compare_at_price != null) {  mainPriceQuantityDiscount = selectedVariant.compare_at_price * item.quantity;} else { mainPriceQuantityDiscount = item.original_line_price;}
                let mainSavingPriceDiscount;
if (selectedVariant.compare_at_price != null) {  mainSavingPriceDiscount = mainPriceQuantity - item.line_price; }else{ mainSavingPriceDiscount = item.original_line_price - item.line_price; }
                 priceListHTML = ` <price-list class="price-list price_flex product_list_flex discount_price_list">
                                <div class="discount_main_price">        
                                    <compare-at-price class="comapre_price_discount h6 text-on-sale">
                                        <span class="sr-only">Sale price</span>
                                        <span class="money">${(item.line_price / 100).toFixed(2)}</span>
                                    </compare-at-price>
                     <sale-price class="discound_code_price  h6 text-subdued ">
                                        <span class="sr-only">Regular price</span>
                                        <span class="money">${(mainPriceQuantityDiscount / 100).toFixed(2)}</span>
                                    </sale-price>
                                </div>
                                <div class="price_sale_saving">  
                                    <p>  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                                            <path d="M0.6875 5.84375L3.64904 9.125L10.3125 2.5625" stroke="#1F3438" stroke-width="1.2375" stroke-linecap="round"></path>
                                        </svg> &nbsp; ${ (window.langify?.locale?.language_code === 'ar') ? "وفر" : "Savings" } &nbsp; <span class="money">${(mainSavingPriceDiscount / 100).toFixed(2)}  </span> &nbsp;
                                       
                                    </p>
                                </div>
                        </price-list>`;
              }else{
                if (selectedVariant.compare_at_price > 0 && selectedVariant.compare_at_price > selectedVariant.price) {
                    priceListHTML = `
                        <price-list class="price-list price_flex product_list_flex">
                            <div class="price_comape_count">
                                <div class="price_option">        
                                    <sale-price class="h6 text-subdued sale_compare_price">
                                        <span class="sr-only">Regular price</span>
                                        <span class="money">${mainPriceQuantity / 100}</span>
                                    </sale-price>
                                    <compare-at-price class="h6 text-on-sale">
                                        <span class="sr-only">Sale price</span>
                                        <span class="money">${(item.line_price / 100).toFixed(2)}</span>
                                    </compare-at-price>
                                </div>
                                <div class="price_sale_saving">  
                                    <p> <svg xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
                                            <path d="M0.6875 5.84375L3.64904 9.125L10.3125 2.5625" stroke="#1F3438" stroke-width="1.2375" stroke-linecap="round"></path>
                                        </svg> &nbsp; ${ (window.langify?.locale?.language_code === 'ar') ? "وفر" : "Savings" } &nbsp;  <span class="money">${mainSavingPrice / 100}</span> &nbsp;
                                        
                                    </p>
                                </div>
                            </div>
                        </price-list>`;
                } else {
                    priceListHTML = `
                        <price-list class="price-list price_flex product_list_flex no_compare_price">
                            <sale-price class="h6 text-on-sale">
                                <span class="sr-only">Price</span>
                                <span class="money">${(item.line_price / 100).toFixed(2)}</span>
                            </sale-price>
                        </price-list>`;
                }}

item_drawer_keyval.forEach(eve => {
    const itemKey = eve.getAttribute('product_line_key');
    if (item.key === itemKey) {
      const targetElement = eve.querySelector('.cart_product_val .price-list');
      if (targetElement) {
        targetElement.outerHTML = priceListHTML;
      }
    }
  });


                let mainPriceQuantitysub = selectedVariant.compare_at_price > 0
                    ? selectedVariant.compare_at_price * item.quantity
                    : item.final_line_price;

              let compare_price_check = selectedVariant.compare_at_price > 0 ? selectedVariant.compare_at_price * item.quantity : 0;
              compare_price_main += compare_price_check;

                if (selectedVariant.compare_at_price > 0) allCompareAtPriceZero = false;
                totalPriceSub += mainPriceQuantitysub;
            });

            let saving_price_final = totalPriceSub - fetchCart.total_price;
 
            // Handle Discount Logic
        if(compare_price_main > 0){ 
          // debugger;
      let sub_compare = totalPriceSub - fetchCart.total_price ;
      $('span.cart-drawer__button-price.saving_total_price').find('.sub_total_main ').html(`<span class="money">${( sub_compare / 100).toFixed(2)}</span>`);
      $('span.cart-drawer__button-price.saving_total_price').show();
           $('span.cart-drawer__button-price.disccount_price').hide();
        }else if (fetchCart.total_discount > 0) {
               let discount_price_final = totalPriceSub - fetchCart.total_price;
                if ($('.disccount_price').length < 1) {
                    $('.total_discount_price').before(`
                        <span class="cart-drawer__button-price disccount_price skeleton_list">
                            <p>${ (window.langify?.locale?.language_code === 'ar') ? "وفر" : "Savings" } <span class="sub_total_main"><span class="money">${(fetchCart.total_discount / 100).toFixed(2)}</span></span></p>
                        </span>`);
                } else {
                    $('span.cart-drawer__button-price.disccount_price').show();
                    $('span.cart-drawer__button-price.disccount_price .sub_total_main').html(`<span class="money">${(fetchCart.total_discount / 100).toFixed(2)}</span>`);
                }
          $('span.cart-drawer__button-price.saving_total_price').hide();
        }else{
           $('span.cart-drawer__button-price.saving_total_price').hide(); 
          $('span.cart-drawer__button-price.disccount_price').hide();
        }

        // subtotal 
         if(compare_price_main > 0 || fetchCart.total_discount > 0){ 
             if($('span.cart-drawer__button-price.sub_compare_price').length < 1){
                $('.disccount_price').before(`<span class="cart-drawer__button-price sub_compare_price skeleton_list">
                <p>SUBTOTAL <span class="sub_total_main"><span class="money">${(totalPriceSub / 100).toFixed(2)}</span></span></p></span>`);
              }else{
               $('span.cart-drawer__button-price.sub_compare_price').show(); 
               $('span.cart-drawer__button-price.sub_compare_price .sub_total_main').html(`<span class="money">${(totalPriceSub / 100).toFixed(2)}</span>`);
             }
         }
           else{
            $('span.cart-drawer__button-price.sub_compare_price').hide();
           }
          
 
        // Discount Logic end

            // Update Subtotal and Hide Savings if Necessary
            $('span.cart-drawer__button-price.total_discount_price .sub_total_main').html(`<span class="money">${(fetchCart.total_price / 100).toFixed(2)}</span>`);

            if (totalPriceSub === fetchCart.total_price) {
                $('span.cart-drawer__button-price.saving_total_price').hide();
            }

      isUpdatingCartSavings = false; // ✅ Allow future calls again
        resolve(); 
    }).catch((err) => {
      isUpdatingCartSavings = false; // Ensure flag resets on error
          reject(err);
    });
  }).fail(() => {
    isUpdatingCartSavings = false;
      reject();
  });
  });
}
function footerHeight(){               
  var footer = document.querySelector('.cart-drawer__footer');
          var mainContent = document.querySelector('.test_cart_drawer');
          if (footer && mainContent) {
            var footerHeight = footer.offsetHeight + 65;
            mainContent.style.minHeight = `calc(100dvh - ${footerHeight}px)`;
          }
               
}
// add to cart
$(document).on("click", '.v-stack .buy-buttons .button', function (e) {
  // debugger;
    var $button = $(this);
    var $productVariantCustomData = $button.closest('.product_variant_custom_data');
    var $personInput = $productVariantCustomData.find('#person_input_cust');
    var $persInitialsLabel = $productVariantCustomData.find('.pers_initials #lblError');
    var escapedFormattedValue = $('.variant__template .variant-picker__option variant-option-value').text().replace(/\/\s*|\s+/g, '').trim().toLowerCase();
    var personalization_avilable = $button.parents('.product_variant_custom_data').find('.personalization_bag');

    // Helper function to show error and scroll
    function showError(errorText) {
        $persInitialsLabel.text(errorText);
        var headerHeight = $('header.shopify-section-group-header-group').outerHeight() || $('.mo-header-sticky').outerHeight();
        $('html, body').animate({
            scrollTop: $personInput.offset().top - headerHeight
        }, 1000, function() {
            $personInput.focus(); 
        });
        setTimeout(function(){  
            $button.removeClass('is-loading');
            $button.find('span svg').hide();
            $('.tpAddToCartBtn .buttonText span.hi_fade').fadeIn();
            $button.removeAttr('disabled');
        }, 600);
    }

    // Check for personalization condition
    if ((escapedFormattedValue.includes('nostripes') || escapedFormattedValue.includes('بدونخطوط')) && !$personInput.val()) {
        showError(window.langify.locale.language_code === 'ar' ? 'أضف الأحرف الأولى' : 'Add Initials');
    } else if ((escapedFormattedValue.includes('initials') || escapedFormattedValue.includes('الأحرفالأولى')) && !$personInput.val()) {
        showError(window.langify.locale.language_code === 'ar' ? 'أضف الأحرف الأولى' : 'Add Initials');
    } else {
        e.preventDefault();
        $button.addClass('is-loading');
        $button.find('span svg').show();
        $button.find("span.hi_fade").hide();

        var items = [];
        var formData_cust = new FormData();
        var cartNote = $('.comp_checkbox_wrap.gift_che_add').find('.gift_note_pro').val();
      var personalization_initi_value = $(this).parents('.product_variant_custom_data').find('.personalization_bag');
        var personalizeText = $('.custom_personalize #person_input_cust').val();
        var personalizeColor = $('.custom_personalize #person_color').val();
        var giftWrap = $('.comp_checkbox.gift_che .box_gift.gift_check').find('.comp_label input[type="checkbox"]').val();
        var giftProp = $('.comp_checkbox.gift_che').find('#gift_box').val();

        // Collect checked upsell items
        $('.secondStrapSlider .item input[type="checkbox"]:checked').each(function() {
            var variantid = parseInt($(this).val());
            var itemProperties = {
                "_Product Upsell": $button.attr('product_sku'),
                "Gift Wrapping": giftWrap,
                "_Gift Wrapping Type": giftProp
            };
            if(cartNote != '') {
                itemProperties["Card Note"] = cartNote;
            }
            items.push({ id: variantid, quantity: 1, properties: itemProperties });
        });

        // Add main item with personalization
       if(cartNote != '') {
        var mainItemProperties = { "Gift Wrapping": giftWrap, "_Gift Wrapping Type": giftProp , "Card Note" : cartNote };
       }else{
         var mainItemProperties = { "Gift Wrapping": giftWrap, "_Gift Wrapping Type": giftProp };
       }
        if (personalizeText) {
            mainItemProperties[window.langify.locale.language_code === 'ar' ? "الأحرف الأولى" : "Initials"] = personalizeText;
            mainItemProperties["Personalize Color"] = personalizeColor;
           
        }
      if (personalization_avilable.length > 0) {
         mainItemProperties[window.langify.locale.language_code === 'ar' ? "السلع المخصصة" : "personalized goods"] = "Yes";
      }
        items.push({ id: parseInt($button.attr("variant_id")), quantity: 1, properties: mainItemProperties });

        if (items.length > 0) {
            formData_cust = { 'items': items };

            // Use fetch API to add items to the cart
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData_cust)
            })
            .then(resp => resp.json())
            .then(data => checkAndAddFreeProducts())
            .catch(error => console.error('Error:', error));
        }

        function checkAndAddFreeProducts() {
            $.getJSON('/cart.json').then(cart => {
                var cartTotal = cart.total_price / 100;
                var freeProduct1ID = window.shopSettings?.freeProductThresholdID1 ?? null;
                var freeProductThreshold1 = window.shopSettings?.freeProductThreshold1 ?? null;
                var freeProduct2ID = window.shopSettings?.freeProductThresholdID2 ?? null;
                var freeProductThreshold2 = window.shopSettings?.freeProductThreshold2 ?? null;

                if (freeProduct1ID || freeProduct2ID) {
                    addFreeProductsIfEligible(cart, freeProduct1ID, freeProductThreshold1, freeProduct2ID, freeProductThreshold2);
                } else {
                    updateCartData();
                }
            });
        }

        function addFreeProductsIfEligible(cart, freeProduct1ID, freeProductThreshold1, freeProduct2ID, freeProductThreshold2) {
            const freeItemsToAdd = [];
            const updates = {};
            let hasChanges = false;
            var cartTotal = cart.total_price / 100;

            // Check eligibility for free products and add if necessary
           if (freeProductThreshold1 && cartTotal >= freeProductThreshold1 && freeProduct1ID && !cart.items.find(item => item.id === freeProduct1ID)) {
    freeItemsToAdd.push({ id: freeProduct1ID, quantity: 1 , properties : { '_Free' : 'Free'} });
    hasChanges = true;
}

if (freeProductThreshold2 && cartTotal >= freeProductThreshold2 && freeProduct2ID && !cart.items.find(item => item.id === freeProduct2ID)) {
    freeItemsToAdd.push({ id: freeProduct2ID, quantity: 1 , properties : { '_Free' : 'Free'} });
    hasChanges = true;
}


            if (hasChanges) {
                $.ajax({
                    url: '/cart/add.js',
                    type: 'POST',
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify({ items: freeItemsToAdd }),
                    success: updateCartData,
                    error: (xhr, status, error) => console.error("Error adding free products:", error)
                });
            } else {
                updateCartData();
            }
        }

        function updateCartData() {
          
                fetch('/?section_id=cart-drawer')
                    .then(response => response.text())
                    .then(text => {
                      // debugger;
                        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                        $('#cart-drawer').html(sectionInnerHTML.getElementById('cart-drawer').innerHTML);
                     updateCartSavingsdisc(); 
                         let recommAdd = document.querySelector('.product-card-recommadation-js .swiper-wrapper');
  if (recommAdd.children.length === 0) {
    updateRelatedProducts(recommAdd)
      .then(() => {
        initializeSwiper(); // Initialize Swiper after products are rendered
      })
      .catch(error => {
        console.error('Error updating related products:', error);
      });
  }
                        $('[aria-controls="cart-drawer"]')[0].click();
           $.getJSON('/cart.json').then(cart => {
  if (!cart || !cart.items) return;

  // Calculate count excluding free items
 let actualItemCount = 0;
  let hasFreeItem = false;

  cart.items.forEach(item => {
    const isFree = item.properties && item.properties["_Free"] === "Free";
    if (isFree) {
      hasFreeItem = true;
    } else {
      actualItemCount += item.quantity;
    }
  });

  // Show or hide the cart count badge
  const $cartCount = $('span.Header__CartCount');
  if (actualItemCount > 0) {
    $cartCount.removeClass('hide_cart_count');
  } else {
    $cartCount.addClass('hide_cart_count');
  }

  // Update the cart count text
  const finalCount = hasFreeItem ? Math.max(actualItemCount, 0) : actualItemCount;
  $('.cart_drawer_ou .Header__CartCount').text(finalCount);

  // Remove loading state
  $(".buy-buttons .button").removeClass('is-loading');
});

                                                          
 footerHeight();
            });
        }
    }

    // Final reset actions
    setTimeout(() => {
        $button.find('span svg').hide();
        $button.find(".buttonText span.hi_fade").fadeIn();
        $('.recommendation_main').removeClass('loadingsection');
    }, 600);
});
// discount

document.addEventListener("DOMContentLoaded", function(event) {

async function fetchCartItems(skipFreeGiftCheck = false, ) {
  try {
    let response = await fetch('/cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Failed to fetch cart');

    let cart = await response.json();

    if (!cart.items || cart.items.length === 0) {
      console.log('Empty cart, retrying...');
      return await fetchCartItems(true, true); // Avoid infinite loop and savings update
    }
    
    if (!skipFreeGiftCheck) await addFreeProductsIfEligibledis();

    let sectionRes = await fetch('/?section_id=cart-drawer');
    let text = await sectionRes.text();
    let sectionHTML = new DOMParser().parseFromString(text, 'text/html');

    
    let cartHTML = sectionHTML.getElementById('cart-drawer-list')?.innerHTML || '';
    let shippingHTML = sectionHTML.getElementById('shipping_bar_drawer')?.innerHTML || '';

    let $cartDOM = $('<div>').html(cartHTML);
console.log($cartDOM);
$cartDOM.find('.cart_product_val .price-list').addClass('loading');
  await updateCartSavingsdisc();
// Inject only the inner modified content
$('#cart-drawer-list').html($cartDOM.html());
    $('#shipping_bar_drawer').html(shippingHTML);
 

    setTimeout(() => {
      let footerHeight = document.querySelector('.cart-drawer__footer')?.offsetHeight || 0;
      document.querySelector('.test_cart_drawer').style.minHeight = `calc(100dvh - ${footerHeight + 65}px)`;
    }, 1000);

   

 $('.cart-drawer__items .cart_product_val .loader').removeClass('loading').fadeOut();
     $('.cart-drawer__footer .sub_total_main, .line-item-quantity.h-stack, .strapCheckbox.recommend_add, .custom_item_drawer .close-cart').removeClass('loading');
    $('.quantity-selector__button').css('pointer-events', 'auto');
            
            $('.cart-drawer__footer .cart_bottom_buttom .cart-drawer__button-price .sub_total_main').removeClass('loading');
            $('.cart-drawer__items .line-item-info line-item-quantity.h-stack , .cart-drawer .strapCheckbox.recommend_add , .custom_item_drawer .cart_price_remove_val .close-cart').removeClass('unclick_load_time');
    $('.cart-drawer__items .cart_product_val .price-list').removeClass('loading');

    // return cart;
  } catch (error) {
    console.error('fetchCartItems error:', error);
  }
}

async function addFreeProductsIfEligibledis() {
  try {
    let res = await fetch('/cart.js', { cache: 'no-store' });
    let cart = await res.json();
    let cartTotal = cart.total_price / 100;

    let freeProduct1ID = window.shopSettings?.freeProductThresholdID1;
    let freeProductThreshold1 = window.shopSettings?.freeProductThreshold1;
    let freeProduct2ID = window.shopSettings?.freeProductThresholdID2;
    let freeProductThreshold2 = window.shopSettings?.freeProductThreshold2;

    let findItemById = (id) => cart.items.find(item => item.id === id);
    let product1InCart = findItemById(freeProduct1ID);
    let product2InCart = findItemById(freeProduct2ID);

    let itemsToAdd = [];
    let updates = {};
    let hasChanges = false;

    if (freeProductThreshold1 && cartTotal >= freeProductThreshold1 && !product1InCart && freeProduct1ID) {
      itemsToAdd.push({ id: freeProduct1ID, quantity: 1 , properties : { '_Free' : 'Free'} });
      hasChanges = true;
    }

    if (freeProductThreshold2 && cartTotal >= freeProductThreshold2 && !product2InCart && freeProduct2ID) {
      itemsToAdd.push({ id: freeProduct2ID, quantity: 1 , properties : { '_Free' : 'Free'} });
      hasChanges = true;
    }

    if (product1InCart && (cartTotal < freeProductThreshold1 || product1InCart.final_line_price > 0)) {
      updates[freeProduct1ID] = 0;
      hasChanges = true;
    }

    if (product2InCart && (cartTotal < freeProductThreshold2 || product2InCart.final_line_price > 0)) {
      updates[freeProduct2ID] = 0;
      hasChanges = true;
    }

    let requests = [];

    if (itemsToAdd.length > 0) {
      requests.push(
        $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({ items: itemsToAdd })
        })
      );
    }

    if (Object.keys(updates).length > 0) {
      requests.push(
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        })
      );
    }

    if (hasChanges) {
      await Promise.all(requests);
          // ✅ Refresh only cart section, not the full fetchCartItems
      let sectionRes = await fetch('/?section_id=cart-drawer');
      let text = await sectionRes.text();
      let sectionHTML = new DOMParser().parseFromString(text, 'text/html');

      let cartHTML = sectionHTML.getElementById('cart-drawer-list')?.innerHTML || '';
      let shippingHTML = sectionHTML.getElementById('shipping_bar_drawer')?.innerHTML || '';

         let $cartDOM = $('<div>').html(cartHTML);
console.log($cartDOM);
$cartDOM.find('.cart_product_val .price-list').addClass('loading');

  $('#cart-drawer-list').html($cartDOM.html());
      $('#shipping_bar_drawer').html(shippingHTML);
    }

  } catch (error) {
    console.error('addFreeProductsIfEligibledis error:', error);
  }
}

  let authorization_token;  
  let checkoutContainer = document.createElement('div');
  document.body.appendChild(checkoutContainer);
  // if (localStorage.discountCode) applyDiscount( JSON.parse(localStorage.discountCode).code);
   $(document).on("click","#redemDevPromo",function(e){  
    e.preventDefault();
     $('.cart-drawer__items .line-item-info line-item-quantity.h-stack , .cart-drawer .strapCheckbox.recommend_add , .custom_item_drawer .cart_price_remove_val .close-cart').addClass('unclick_load_time');
$('.cart-drawer__items  .cart_product_val .price-list').addClass('loading');
$('.cart-drawer__footer  .cart_bottom_buttom .cart-drawer__button-price .sub_total_main').addClass('loading');
      $('.Cart__Checkout').css('pointerEvents', 'none');
      applyDiscount(document.querySelector("#devPromo").value,true);     
  });
    $(document).on("click", '#clear-discount-btn' ,function(e) {
    e.preventDefault();
       $('.Cart__Checkout').css('pointerEvents', 'none');
        $('.cart-drawer__items .line-item-info a.quantity-selector__button').css('pointer-events', 'none');
    clearDiscount();
      $('.cart-drawer__items .line-item-info line-item-quantity.h-stack , .cart-drawer .strapCheckbox.recommend_add , .custom_item_drawer .cart_price_remove_val .close-cart').addClass('unclick_load_time');
$('.cart-drawer__items  .cart_product_val .price-list').addClass('loading');
$('.cart-drawer__footer  .cart_bottom_buttom .cart-drawer__button-price .sub_total_main').addClass('loading');
  });
function clearDiscount() {
    clearLocalStorage();
      // fetchCartItems();
      // Add cart.json updater before fetchCartItems
    fetch('/cart.json')
      .then(response => response.json())
      .then(cart => {
        // Process the cart data if needed
        console.log('Current cart state:', cart);
        
        // Now make the request to clear the discount
        return fetch("/discount/CLEAR");
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to clear discount');
        }
        return fetch('/cart.json'); // Fetch updated cart after clearing discount
      })
      .then(response => response.json())
      .then(updatedCart => {
        console.log('Updated cart after discount cleared:', updatedCart);
        
        // Now fetch cart items to update the UI
        fetchCartItems();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        // Still try to fetch cart items even if there was an error
        fetchCartItems();
      });
    $('.disc_promo').addClass('remove_discount_click');
    $('#devPromo_new').val('');
    $('#discount-code-error').hide().text('');
  setTimeout(function(){
    if($('#devPromo_new').val().length == 0){
    document.querySelector('.disc_promo').style.display = 'none'; 
    document.querySelector('.custom-coupon').style.display = 'flex'; 
    document.getElementById('devPromo').value = ''
   }
  },1000);
   
    fetch("/discount/CLEAR");
  }
function clearLocalStorage() {
    if(localStorage.discountCode){
    if($('.applied-discount-code-wrapper')) $('.applied-discount-code-wrapper').css('display' , "none");
    if($(".cart-drawer__button-price .money")) $(".cart-drawer__button-price .money").innerHTML = JSON.parse(localStorage.discountCode).totalCart;
    localStorage.removeItem("discountCode");
    }
  }
async function applyDiscount(code, isCardActualUpdate = false) {
  try {
    if ($("#redemDevPromo").length) {
      $("#redemDevPromo").html("APPLYING <div class='loader'></div>").css('pointerEvents', 'none');
    }
    const cartPromise = fetch('/cart.js').then(res => res.json());
    const discountResponse = await fetch(`/discount/${code}`);
   const [originalCartData, updatedCartResponse] = await Promise.all([
      cartPromise,
      fetch('/cart.js').then(res => res.json())
    ]);

    const discountApplied = updatedCartResponse.total_discount > originalCartData.total_discount;

    if (discountApplied) {
      localStorage.setItem("discountCode", JSON.stringify({
        code: code.trim(),
        totalCart: originalCartData.total_price
      }));

      if ($('.applied-discount-code-wrapper').length)
        $('.applied-discount-code-wrapper').css('display', "inline");
      
      $('#discount-code-error').hide().text('');
      if ($("#devPromo").val()) $('#devPromo_new').val(code);

      // Auto-resize the input width
      const tempSpan = document.createElement("span");
      tempSpan.style.visibility = "hidden";
      tempSpan.style.whiteSpace = "nowrap";
      tempSpan.textContent = code;
      document.body.appendChild(tempSpan);
      const width = tempSpan.offsetWidth + 12;
      document.body.removeChild(tempSpan);
      document.getElementById("devPromo_new").style.setProperty("width", width + "px", "important");

      // debugger;
      // Show applied code UI
      if (document.querySelector('.disc_promo')) {
        document.querySelector('.disc_promo').style.display = 'inline-block';
      }
      if (document.querySelector('.custom-coupon')) {
        document.querySelector('.custom-coupon').style.display = 'none';
      }
      // $('.cart-promo .promo_box').hide();
      // $('.cart-promo h2').removeClass('active');
      $('.disc_promo').removeClass('remove_discount_click');

      if (isCardActualUpdate) fetchCartItems();

    } else {
      $('#devPromo_new').val('');
      $('#discount-code-error').show().text("Please Enter Valid Coupon Code.");
      $('.cart-drawer__items .cart_product_val .loader').removeClass('loading').fadeOut();
     $('.cart-drawer__footer .sub_total_main, .line-item-quantity.h-stack, .strapCheckbox.recommend_add, .custom_item_drawer .close-cart').removeClass('loading');
    $('.quantity-selector__button').css('pointer-events', 'auto');
            
            $('.cart-drawer__footer .cart_bottom_buttom .cart-drawer__button-price .sub_total_main').removeClass('loading');
            $('.cart-drawer__items .line-item-info line-item-quantity.h-stack , .cart-drawer .strapCheckbox.recommend_add , .custom_item_drawer .cart_price_remove_val .close-cart').removeClass('unclick_load_time');
    $('.cart-drawer__items .cart_product_val .price-list').removeClass('loading');

      $('#devPromo').val('');
      clearLocalStorage();

      $('.line-item-quantity.h-stack, .strapCheckbox.recommend_add, .custom_item_drawer .close-cart').removeClass('loading');
    }

  } catch (error) {
    console.error("Error applying discount:", error);
  } finally {
    $("#redemDevPromo").html("APPLY").css('pointerEvents', 'all');
    $('.Cart__Checkout').css('pointerEvents', 'all');
  }
}

});

// discount end
// onload

let isCartLoading = false;

function updateCartDataLoaddata() {
  return $.getJSON('/cart.json').then(cart => {
    return fetch('/?section_id=cart-drawer')
      .then(res => res.text())
      .then(text => {
        const html = new DOMParser().parseFromString(text, 'text/html');
             updateCartSavingsdisc();
        $('#cart-drawer-list').html(html.getElementById('cart-drawer-list')?.innerHTML);
        $('#shipping_bar_drawer').html(html.getElementById('shipping_bar_drawer')?.innerHTML);
        $('#cart_drawer__footer_load').html(html.getElementById('cart_drawer__footer_load')?.innerHTML);

        $('.cart-drawer__footer .cart-drawer__button-price.saving_total_price').hide();
        // $('.cart_drawer_ou .Header__CartCount').text(cart.item_count);

          // Calculate count excluding free items
 let actualItemCount = 0;
  let hasFreeItem = false;

  cart.items.forEach(item => {
    const isFree = item.properties && item.properties["_Free"] === "Free";
    if (isFree) {
      hasFreeItem = true;
    } else {
      actualItemCount += item.quantity;
    }
  });

  // Show or hide the cart count badge
  const $cartCount = $('span.Header__CartCount');
  if (actualItemCount > 0) {
    $cartCount.removeClass('hide_cart_count');
  } else {
    $cartCount.addClass('hide_cart_count');
  }

  // Update the cart count text
  const finalCount = hasFreeItem ? Math.max(actualItemCount, 0) : actualItemCount;
  $('.cart_drawer_ou .Header__CartCount').text(finalCount);


      

        if (!$('.recommendation_main .swiper-wrapper').is(':empty')) {
      

          const recommAdd = document.querySelector('.product-card-recommadation-js .swiper-wrapper');
          if (recommAdd && recommAdd.children.length === 0) {
            return updateRelatedProducts(recommAdd)
              .then(() => initializeSwiper())
              .catch(error => console.error('Error updating related products:', error));
          }
        }
      });
  });
}

function checkoutbackdeta() {
  if (isCartLoading) return;
  isCartLoading = true;

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (cart.item_count > 0) {
        // Prepare DOM
        $('.cart-drawer__footer').find('#upsel-checkbx-card, #upsel-checkbx-colour').removeAttr('name');
        // $('.cart-drawer__items .cart_product_val .price-list').addClass('loading');
        // $('.cart-drawer__footer .cart_bottom_buttom .cart-drawer__button-price .sub_total_main').addClass('loading');

        // Clear gift wrapping
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              "Gift Wrapping": "",
              "_Gift Wrapping Type": ""
            }
          })
        });
      }
    })
    .then(() => updateCartDataLoaddata())
    .catch(err => console.error('Checkout load error:', err))
    .finally(() => {
      isCartLoading = false;
      footerHeight();
      // $('.cart-drawer__items .cart_product_val .price-list').removeClass('loading').fadeIn();
      // $('.cart-drawer__footer .cart_bottom_buttom .cart-drawer__button-price .sub_total_main').removeClass('loading');
    });
}
function discountCodeapplied() {
                 // applied discound on load

           fetch('/cart.json')
  .then(response => response.json())
  .then(data => {
    // console.log('Cart Data:', data);
    // debugger;
    if(data.cart_level_discount_applications.length != 0){  
      data.cart_level_discount_applications.forEach(function(k, v){
    if(k.type == 'discount_code'){
       if ($('.applied-discount-code-wrapper')) $('.applied-discount-code-wrapper').css('display', "inline");
       $('#discount-code-error').hide();
      if ($('#discount-code-error').text('')) $('#discount-code-error').hide().text("");
      if ($("#devPromo").val()) {    $('#devPromo_new').val(k.title);   }
           if (document.querySelector('.disc_promo #devPromo_new')) {
        if (document.querySelector('.disc_promo #devPromo_new').value.length == 0) { 
          document.querySelector('.disc_promo #devPromo_new').value = k.title;  } }
      if ($('#devPromo_new').val()) {

        
        if (document.querySelector('.disc_promo') || document.querySelector('.custom-coupon')) {

                  var tempSpan = document.createElement("span");
tempSpan.style.visibility = "hidden"; 
tempSpan.style.whiteSpace = "nowrap"; 
tempSpan.textContent = k.title;
document.body.appendChild(tempSpan);
var textWidth_data = tempSpan.offsetWidth + 12;
document.body.removeChild(tempSpan);
document.getElementById("devPromo_new").style.setProperty("width", textWidth_data + "px", "important");
          
          document.querySelector('.disc_promo').style.display = 'inline-block';
          document.querySelector('.custom-coupon').style.display = 'none';
        }
      } else {
        if (document.querySelector('.disc_promo') || document.querySelector('.custom-coupon')) {
          document.querySelector('.disc_promo').style.display = 'none';
          document.querySelector('.custom-coupon').style.display = 'flex';
        }
      }
    } }); } 
  
//    let footer_height = document.querySelector('.cart-drawer__footer');
//     if(footer_height){
// let footerHeight_auto = footer_height.offsetHeight + 65; 
// let mainContent_auto = document.querySelector('.test_cart_drawer'); 
// mainContent_auto.style.minHeight = `calc(100dvh - ${footerHeight_auto}px)`;
//     }
  });
}

let cartInitialized = false;

function initializeCartDrawerLoad() {
  if (!cartInitialized) {
    cartInitialized = true;
    checkoutbackdeta();
  }
}
let number_of_div = $('#cart-drawer #cart-drawer-list .Cart__ItemList').length;
fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {       
       if(cart.items.length != number_of_div){
         // alert("click");
           document.addEventListener('DOMContentLoaded', initializeCartDrawerLoad);
window.addEventListener('pageshow', initializeCartDrawerLoad);
discountCodeapplied();
      
       }else{
         updateCartSavingsdisc();
var intervalId = setInterval(() => {
  var footer = document.querySelector('.cart-drawer__footer');
  var mainContent = document.querySelector('.test_cart_drawer');

  if (footer && mainContent) {
    var footerHeight = footer.offsetHeight + 65;

    if (footerHeight > 65) {
      mainContent.style.minHeight = `calc(100dvh - ${footerHeight}px)`;
    } else {
      mainContent.style.minHeight = '';
    }

    // Once height is applied or cleared, stop checking
    clearInterval(intervalId);
  }
}, 10);

discountCodeapplied();

       }
    });
// On load get data